<script>

import functions from '../../mixins/import/handle_duplicates.js';

export default {
	data() {
		return {
			path: '/import-customers/'
		}
	},
	mixins: [functions],
	methods: {
		async onConfirm(e) {

			this.isLoading = true;

			await axios.post(this.path + this.id + '/handle-duplicate', {
				rows: this.duplicateRows,
				duplicated_by: this.duplicatedBy,
				duplicated_value: this.duplicatedValue,
				skip_duplicate_check: this.doSkipDuplicateCheck
			}).then(response => {

				this.loadDuplicates();

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				flash('Handling failed, please check the form data!', 'danger');

			});

			this.isLoading = false;
			this.doSkipDuplicateCheck = false;

		},
		async loadDuplicates() {

			await axios.get(this.path + this.id + '/get-duplicate').then(response => {

				if (response.data.duplicates.total_rows > 0) {
					this.setRow(response.data);

				} else {
					window.location = '/import/' + this.id +  '/summary';
				}

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

			});

		},
		fieldsIdentical(rows, field) {

			let values = [];

			for (let j = 0; j < rows.length; j++) {

				if (field === 'city') {
					values.push(rows[j].city);
				} else if (field === 'address') {
					values.push(rows[j].address);
				} else if (field === 'postal_code') {
					values.push(rows[j].postal_code);
				} else if (field === 'note') {
					values.push(rows[j].note);
				} else if (field === 'email_marketing_agreement') {
					values.push(rows[j].email_marketing_agreement);
				} else if (field === 'sms_marketing_agreement') {
					values.push(rows[j].sms_marketing_agreement);
				}

			}

			return (_.uniq(values).length === 1);
		}
	}
}

</script>